import { Permission, userHasPermission } from '@customer/permissions';
import { useAppSelector } from '@customer/store/hooks';
import { ReactNode } from 'react';
import WelcomeModal from './WelcomeModal';

interface WelcomeInjectorProps {
  children: ReactNode;
}

export const WelcomeInjector = ({ children }: WelcomeInjectorProps) => {
  const userData = useAppSelector(state => state.auth);
  const isLimitedAccess = !userHasPermission(userData, Permission.SiteDataRead);

  return (
    <>
      {children}
      {isLimitedAccess && <WelcomeModal />}
    </>
  );
};

export default WelcomeInjector;
